<template>
  <div class="mit-wireless-password-change-page mit-page mit-page">
      <BaseMitLoading :show="loadingSettings || loadingValidation" :overlayFullscreen="false"/>
      <v-snackbar top :color="status.color" min-width="0" v-model="status.display" :timeout="status.timeout">
        <b>{{ status.message }}</b>
      </v-snackbar>
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Manage Wi-Fi Password</v-card-title>
            <v-card-subtitle v-if="featureToggleUseTempDoc" class="caption">Create a new or change your CSAIL Wi-Fi password here. Connection steps can be found on <a href="https://tig.csail.mit.edu/network-wireless/csailprivate-new/" target="_blank">TIG wireless information page</a> </v-card-subtitle>
            <v-card-subtitle v-else class="caption">Create a new or change your CSAIL Wi-Fi password here. Connection steps can be found on <a href="https://tig.csail.mit.edu/network-wireless/csailprivate/" target="_blank">TIG wireless information page</a> </v-card-subtitle>
            <v-divider></v-divider>
            
            <v-card v-if="state === 'new'">
              <v-card-text>
                <!-- <h3 color="primary" class="pb-5 pt-3">Wi-Fi Network "{{ selectedWifiName }}"</h3> -->
                <h3 color="primary" class="pb-5 pt-3">Wi-Fi Network CSAILPrivate</h3>
                <v-form :ref="'passForm'" v-model="isFormValid" lazy-validation>
   
                    <v-row>
                        <v-col cols="12" lg="6">
                          <v-text-field dense class="text--primary pb-0 mb-0" :readonly="true" v-model="changeModel.username" label="Username" background-color="#DCDCDC"></v-text-field>
                          <!-- <p class="font-weight-thin text--caption pl-3 pr-3 pb-3 pt-0 mt-0">When creating the account and logging into {{ selectedWifiName }}, you must use your full CSAIL email address as shown above.</p> -->
                          <p class="font-weight-thin text--caption pl-3 pr-3 pb-3 pt-0 mt-0">When creating the account and logging into CSAILPrivate, you must use your full CSAIL email address as shown above.</p>
                          <v-checkbox v-model="useDefaultPassword" label="Use Generated Password" @change="defaultPasswordChange"></v-checkbox>
                        </v-col>                
                    </v-row>
                    
                    
                    <div v-if="useDefaultPassword">
                      <!-- <v-row>
                        <v-col cols="4">
                          <v-text-field id="mit-default-pass" :readonly="true" v-model="autoGeneratedPass" label="Password" type="text"></v-text-field>
                        </v-col>
                        <v-col>
                          <v-btn class="mt-5" color="" @click="submitChangePassword()" :disabled="isFormValid ===  false">Copy To Clipboard</v-btn>
                        </v-col>                    
                      </v-row> -->
                      <!-- <v-text-field id="mit-default-pass" append-icon="mdi-content-copy" @click:append="copyDefaultPassword" :readonly="true" v-model="autoGeneratedPass" label="Password" type="text"></v-text-field> -->
                      <v-row>
                        <v-col cols="12" lg="6">
                          <v-text-field id="mit-default-pass"  :error-messages="loadingPasswordGenerateError" color="red" :loading="loadingPasswordGenerate" append-icon="mdi-content-copy" append-outer-icon="mdi-refresh" @click:append="copyDefaultPassword" @click:append-outer="generateDefaultPassword" :readonly="true" v-model="autoGeneratedPass" label="Password" type="text"></v-text-field>
                        </v-col>                
                      </v-row>
                    </div>
                    <div v-else>
                      <v-row>
                        <v-col cols="12" lg="6">
                          <p class="mb-0 font-weight-bold">Create Password:</p>
                          <v-text-field v-model="changeModel.newPassword" label="New Password" type="password" :rules="rules.password"></v-text-field>
                          <v-text-field v-model="changeModel.newPasswordConfirm" label="New Password Verify" type="password" :rules="rules.passwordConfirm"></v-text-field>
                        </v-col>                
                      </v-row>
                     
                    </div>
                    
 
                </v-form>
                <v-btn class="mt-5" color="primary" @click="submitChangePassword()" :disabled="isFormValid ===  false">Save</v-btn>
              </v-card-text>
            </v-card>
            <v-card v-if="state === 'loading'" style="height: 400px;">
              <v-row class="fill-height" align-content="center" justify="center">
                <v-col class="text-subtitle-1 text-center" cols="12">
                  <v-progress-circular color="primary" width="5" indeterminate rounded size="100">
                    Saving...
                  </v-progress-circular>
                </v-col>
              </v-row>
            </v-card>
            <v-card v-if="state === 'success'" style="height: 400px;">
                <v-card-text class="text-center pt-10">
                  <div class="text-h4 pb-3"><v-icon large color="green" class="pr-2">mdi-check-circle-outline</v-icon>Success</div>
                  <div class="text-subtitle-1 ">You have successfully set your password for wireless network</div>
                  <div class="text-subtitle-1 ">"<b>CSAILPrivate</b>"</div>
                  <p class="pt-10" v-if="featureToggleUseTempDoc">See <a href="https://tig.csail.mit.edu/network-wireless/csailprivate-new/" target="_blank">CSAIL wireless information page</a> for steps on how to connect.</p>
                  <p class="pt-10" v-else>See <a href="https://tig.csail.mit.edu/network-wireless/csailprivate/" target="_blank">CSAIL wireless information page</a> for steps on how to connect.</p>

                </v-card-text>
            </v-card>
           
            <v-card v-if="state === 'fail'" style="height: 400px;">
                <v-card-text class="text-center pt-10">
                  <div class="text-h4"><v-icon large color="red" class="pr-2">mdi-alert-circle-outline</v-icon>There was an issue</div>
                  <div class="text-subtitle-1 pb-10 error-container" >
                    <div v-if="Array.isArray(errorMessage) && errorMessage.length > 1" class="error-list" style="display: flex; flex-direction: column;gap: 4px;">
                        <div v-for="(msg, index) in errorMessage" :key="index" class="error-item">
                            {{ msg }}
                        </div>
                    </div>

                    <p v-else-if="errorMessage" class="error-item">
                        {{ Array.isArray(errorMessage) ? errorMessage[0] : errorMessage }}
                    </p>
                  </div>
                  <v-btn outlined color="primary" @click="tryAgain()">Try Again</v-btn>
                </v-card-text>
            </v-card>

          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import BaseMitLoading from '../../base/components/BaseMitLoading.vue';
  import BaseMitConfigService from '../../base/services/BaseMitConfigService.js';
  import MitMerakiService from '../services/MitMerakiService.js';
  import MitSettingsService from '../services/MitSettingsService.js';

  export default {
    name: 'MitPasswordChangePage',
    components: {
      BaseMitLoading
    },
    data: function() {
      return {
        status:{
            display:false,
            timeout:9000,
            message:'',
            color:'primary'
        },
        changeModel:{
          username:'',
          newPassword:'',
          newPasswordConfirm:''
        },
        errorMessage:'There was an unknown error setting your Wi-Fi password.',
        useDefaultPassword:true,
        state:'new',// new/loading/success/fail
        isFormValid:true,
        rules: {
                //rules for password come from backend since they are needed for api level validation, one set of rules for everyone :)
                password:[
                  v => !!v || 'Password is required',
                ],
                passwordConfirm:[
                  v => !!v || 'Confirm Password is required',
                  v => this.changeModel.newPassword === this.changeModel.newPasswordConfirm || 'Passwords must match'
                ]
        },
        loadingSettings:true,
        loadingValidation:true,
        loadingPasswordGenerate:true,
        loadingPasswordGenerateError:[],
        autoGeneratedPass:'',
        selectedWifiName:null,
        featureToggleUseTempDoc:false
      }
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    created() {
      this.featureToggleUseTempDoc = BaseMitConfigService.getFeatureEnabled('feature-wifi-doc-csailprivate-new');
      this.generateDefaultPassword();
      // if(this.useDefaultPassword){
      //   //USE linux app diceware
      //   //this needs to be installed in the dockerfile
      //   this.autoGeneratedPass = this.generateDefaultPassword();
      // }
      //Get the current settings so we can see the meraki config
      MitSettingsService.getMerakiSettings()
        .then((settings) => {
          this.selectedWifiName = settings.ssid;
          this.loadingSettings = false;
        })
        .catch((error) => {
          this.loadingSettings = false;
          console.log('Error getting password validation',error);
        });
      //Get the password validation regex from the api
      MitMerakiService.getPasswordValidation()
        .then((validation) => {
          for(let x = 0; x < validation.rules.length; x++){
              this.rules.password.push( v => (new RegExp(validation.rules[x].rule)).test(v) || validation.rules[x].message );
          }
          this.loadingValidation = false;
        })
        .catch((error) => {
          this.loadingValidation = false;
          console.log('Error getting password validation.',error);
        });
      

      this.changeModel.username = this.userModel.email;
    },
    methods: {
      copyDefaultPassword(){
        let textarea = document.getElementById("mit-default-pass");
        textarea.select();
        document.execCommand("copy");
        this.status.message = 'Copied to clipboard!';
        this.status.color = 'primary';
        this.status.display = true;
      },
      generateDefaultPassword(){
        this.autoGeneratedPass = 'Loading...';
        this.loadingPasswordGenerateError = [];

        MitMerakiService.getPasswordGeneration()
          .then((data) => {
            this.autoGeneratedPass = data.generatedPassword;
            this.loadingPasswordGenerate = false;
          })
          .catch((error) => {
            this.autoGeneratedPass = null;
            this.loadingPasswordGenerate = false;
            this.loadingPasswordGenerateError.push('An error occurred trying to generate a password.');
            console.log('Error getting generated password',error);
          });
        // const regx = new RegExp(/\d/, "g");
        // return window.crypto.getRandomValues(new BigUint64Array(3)).reduce(
        //       (prev, curr, index) => (
        //         !index ? prev : prev.toString(36)
        //         ) + (
        //           index % 2 ? curr.toString(36).toUpperCase().replace(regx, key => ".$#%&*@!".charAt(key)) : curr.toString(36)
        //         )
        //       ).split('').sort(() => 128 -
        //         window.crypto.getRandomValues(new Uint8Array(1))[0]
        //       ).join('');
      },
      defaultPasswordChange(){
        //clear any errors
        this.loadingPasswordGenerateError = [];

        if(this.useDefaultPassword){
          this.autoGeneratedPass = this.generateDefaultPassword();
        }
      },
      tryAgain(){
        this.state = 'new';
      },
      validate(n) {
          this.steps[n].valid = false
          let v = this.$refs.stepForm[n].validate()
          if (v) {
              this.steps[n].valid = true
              // continue to next
              this.curr++;
          }

      },
      submitChangePassword() {
        if(this.$refs.passForm.validate()){

          this.submitted = true;
          this.state = 'loading';
          let changePromise = null;

          if(this.useDefaultPassword){
            changePromise = MitMerakiService.changePassword(this.autoGeneratedPass, this.autoGeneratedPass);
          }
          else{
            changePromise = MitMerakiService.changePassword(this.changeModel.newPassword, this.changeModel.newPasswordConfirm);
          }

          changePromise
              .then((result) => {
                  this.state = 'success';
              })
              .catch((error) => {
                  this.state = 'fail';
                  this.errorMessage = error;
              });

          
         
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height:100vh;
  }
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
